(() => {
  // Native localization controls can call form.submit() directly. Capture their
  // click/change before that handler, as well as ordinary keyboard form submits.
  // The server-rendered return_to remains the no-JavaScript fallback.
  function preserveLocalizationDestination(event) {
    const form = event.target?.closest?.('form');
    if (!form) return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !/\/localization\/?$/.test(action.pathname)) return;
    let destination = form.querySelector('input[name="return_to"]');
    if (!destination) {
      destination = document.createElement('input');
      destination.type = 'hidden';
      destination.name = 'return_to';
      form.appendChild(destination);
    }
    destination.value = window.location.pathname + window.location.search + window.location.hash;
  }
  for (const type of ['click', 'change', 'submit']) {
    document.addEventListener(type, preserveLocalizationDestination, {capture: true});
  }

  function initCatalog(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const links = [...root.querySelectorAll('[data-retail-category]')];
    const groups = [...root.querySelectorAll('[data-retail-group]')];
    const status = root.querySelector('[data-retail-status]');
    const empty = root.querySelector('[data-retail-empty]');
    const allowed = new Set(links.map(link => link.dataset.retailCategory));
    const defaultCategory = root.dataset.defaultCategory || 'all';
    function apply(category) {
      if (!allowed.has(category)) category = defaultCategory;
      let count = 0;
      for (const group of groups) {
        group.hidden = category !== 'all' && group.dataset.retailGroup !== category;
        if (!group.hidden) count += Number(group.dataset.count || 0);
      }
      for (const link of links) {
        if (link.dataset.retailCategory === category) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
      if (status) status.textContent = count === 1 ? status.dataset.countOne : status.dataset.countLabel.replace('__COUNT__', String(count));
      if (empty) empty.hidden = count > 0;
    }
    const fromUrl = () => apply(window.location.hash.slice(1) || defaultCategory);
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-retail-category]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const url = new URL(link.href, window.location.href);
      if (url.pathname !== window.location.pathname) return;
      event.preventDefault();
      if (window.location.hash !== url.hash) window.history.pushState(null, '', url.hash);
      apply(link.dataset.retailCategory);
    });
    window.addEventListener('hashchange', fromUrl);
    window.addEventListener('popstate', fromUrl);
    fromUrl();
  }
  function init() {
    document.querySelectorAll('[data-retail-catalog]').forEach(initCatalog);
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.retail-mobile-menu[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.retail-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a[href]')) menu.open = false;
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.retail-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('shopify:section:load', init);
  init();
})();

(() => {
  const tag = 'retail-shipping-celebration';
  if (!window.customElements || customElements.get(tag)) return;
  const storageKey = 'bonsai:retail-free-shipping-celebrated:v5';
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  let celebrated = false;
  let keyboard = false;
  try { celebrated = sessionStorage.getItem(storageKey) === 'true'; } catch {}
  function remember(value) {
    celebrated = value;
    try {
      if (value) sessionStorage.setItem(storageKey, 'true');
      else sessionStorage.removeItem(storageKey);
    } catch {}
  }
  document.addEventListener('keydown', () => { keyboard = true; }, { capture: true });
  document.addEventListener('pointerdown', () => { keyboard = false; }, { capture: true, passive: true });

  customElements.define(tag, class extends HTMLElement {
    static observedAttributes = ['data-qualified'];
    constructor() {
      super();
      this.frame = 0;
      this.timers = [];
      this.animations = [];
      this.playing = false;
      this.onUpdate = () => this.queueCheck();
    }
    connectedCallback() {
      this.dialog = this.closest('.cart-drawer--retail dialog');
      this.observer = new MutationObserver(this.onUpdate);
      if (this.dialog) this.observer.observe(this.dialog, { attributes: true, attributeFilter: ['open', 'class'] });
      reducedMotion?.addEventListener('change', this.onUpdate);
      document.addEventListener('cart:update', this.onUpdate);
      document.addEventListener('visibilitychange', this.onUpdate);
      this.queueCheck();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      reducedMotion?.removeEventListener('change', this.onUpdate);
      document.removeEventListener('cart:update', this.onUpdate);
      document.removeEventListener('visibilitychange', this.onUpdate);
      this.stop();
      const doc = this.ownerDocument;
      queueMicrotask(() => {
        if (doc.querySelector('.cart-drawer--retail') && !doc.querySelector('.cart-drawer--retail retail-shipping-celebration[data-qualified="true"]')) remember(false);
      });
    }
    attributeChangedCallback(_name, previous, current) {
      if (previous !== current && this.isConnected) this.queueCheck();
    }
    queueCheck() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.check());
    }
    check() {
      if (!this.isConnected) return;
      if (this.dataset.qualified !== 'true') {
        this.stop();
        remember(false);
        return;
      }
      if (!this.dialog?.open || this.dialog.classList.contains('dialog-closing') || document.hidden) {
        this.stop();
        return;
      }
      if (reducedMotion?.matches || keyboard || typeof this.animate !== 'function') {
        this.stop();
        remember(true);
        return;
      }
      if (this.playing && (this.dataset.celebration === 'waiting' || this.confettiLayer?.isConnected)) return;
      if (celebrated) {
        this.stop();
        return;
      }
      this.playing = true;
      this.dataset.celebration = 'waiting';
      this.timers.push(setTimeout(() => this.play(), 450));
    }
    play() {
      if (!this.isConnected || !this.dialog?.open || document.hidden) {
        this.stop();
        return;
      }
      const message = this.querySelector('.retail-cart-shipping__message');
      if (!message) {
        this.stop();
        return;
      }
      remember(true);
      this.playing = true;
      this.dataset.celebration = 'burst';
      const layer = document.createElement('span');
      layer.className = 'retail-cart-shipping__confetti';
      layer.dataset.confettiLayer = '';
      layer.setAttribute('aria-hidden', 'true');
      this.confettiLayer = layer;
      this.dialog.append(layer);
      const colours = ['#bd292f', '#f6bc37', '#69b44e', '#41afd0', '#ef7fa6', '#e77c30'];
      const width = this.dialog.clientWidth || 520;
      const height = this.dialog.clientHeight || window.innerHeight || 800;
      const easing = 'cubic-bezier(0.22, 1, 0.36, 1)';
      try {
        for (let i = 0; i < 128; i++) {
          const piece = document.createElement('span');
          piece.dataset.confettiPiece = '';
          piece.dataset.shape = ['ribbon', 'square', 'ribbon', 'dot'][i % 4];
          piece.style.backgroundColor = colours[i % colours.length];
          const originX = width * (0.44 + Math.random() * 0.12);
          const originY = height * (0.42 + Math.random() * 0.1);
          const targetX = width * (0.03 + ((i % 16 + Math.random()) / 16) * 0.94);
          const targetY = height * (0.02 + ((Math.floor(i / 16) + Math.random()) / 8) * 0.82);
          const fall = height - targetY + 40 + Math.random() * height * 0.18;
          const phase = Math.random() * Math.PI * 2;
          const tilt = Math.random() * 180;
          const spin = (Math.random() - 0.5) * 900;
          const flip = Math.random() * 360;
          const frames = [0, 0.03, 0.07, 0.12, 0.16, 0.24, 0.34, 0.46, 0.6, 0.75, 0.9, 1].map(progress => {
            const pop = 1 - Math.pow(1 - Math.min(progress / 0.16, 1), 3);
            const hanging = Math.max(0, Math.min((progress - 0.16) / 0.18, 1));
            const falling = Math.max(0, (progress - 0.34) / 0.66);
            const flutter = (Math.sin(progress * Math.PI * 6 + phase) - Math.sin(phase)) * 10 * progress;
            const x = originX + (targetX - originX) * pop + flutter;
            const y = originY + (targetY - originY) * pop + hanging * 10 + fall * Math.pow(falling, 1.4);
            const opacity = progress < 0.02 ? progress / 0.02 : progress > 0.9 ? (1 - progress) / 0.1 : 1;
            return {
              offset: progress,
              opacity,
              transform: `translate3d(${x}px, ${y}px, 0) rotate(${tilt + spin * progress}deg) rotateY(${flip + progress * 650}deg)`
            };
          });
          layer.append(piece);
          const delay = Math.random() * 40;
          this.animations.push(piece.animate(frames, { duration: 2800 - delay, delay, easing: 'linear', fill: 'both' }));
        }
        this.timers.push(setTimeout(() => {
          this.dataset.celebration = 'revealing';
          try {
            this.animations.push(message.animate([
              { opacity: 0, transform: 'translateY(4px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 320, easing, fill: 'both' }));
          } catch { this.stop(); }
        }, 650));
        this.timers.push(setTimeout(() => this.stop(), 2800));
      } catch { this.stop(); }
    }
    stop() {
      this.timers.forEach(clearTimeout);
      this.timers = [];
      this.animations.forEach(animation => animation.cancel());
      this.animations = [];
      this.confettiLayer?.remove();
      this.confettiLayer = null;
      this.removeAttribute('data-celebration');
      this.playing = false;
    }
  });
})();
